import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * tailwind-merge can't tell our custom `text-*` font-size tokens (e.g.
 * `text-label-caps`) from our custom `text-*` colour tokens (e.g. `text-primary`)
 * — without this it collapses them into one group and drops one. Register both
 * scales explicitly.
 */
const FONT_SIZES = [
  'display-xl',
  'headline-lg',
  'headline-lg-mobile',
  'headline-md',
  'body-lg',
  'body-md',
  'body-sm',
  'label-caps',
  'label-sm',
]

const TEXT_COLORS = [
  'fg',
  'fg-muted',
  'on-surface',
  'on-surface-variant',
  'outline',
  'outline-variant',
  'primary',
  'on-primary',
  'primary-container',
  'on-primary-container',
  'primary-fixed-dim',
  'secondary',
  'secondary-container',
  'on-secondary-container',
  'error',
]

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: FONT_SIZES }],
      'text-color': [{ text: TEXT_COLORS }],
    },
  },
})

/** Merge conditional class names, resolving Tailwind conflicts last-wins. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
